import React, { Component } from 'react';
import { info_version } from '../../package.json';

class Info extends Component {
    render() {
        return (
            <React.Fragment>
                <div>
                    <center>
                        <p>eOpłaty - {info_version}</p>
                        <p>INFO-SYSTEM Roman i Tadeusz Groszek sp.j. </p>
                        <p>05-120 Legionowo, ul. Piłsudskiego 31 lok. 240 </p>
                        <p>tel: 22 784-49-44, 22 732-01-49, 22 732-01-50 </p>
                        <p>fax: 784 49 88 </p>
                        <p>e-mail: <a href="mailto:poczta@groszek.pl">poczta@groszek.pl</a> </p>
                        <p><a href="http://www.groszek.pl">www.groszek.pl</a> </p>

                    </center>
                </div>
            </React.Fragment>
        );
    }
}

export default Info;